import { object, string, number } from 'yup';

export const outrasInformacoesSchema = object({
  id: string(),
  profissao: string(),
  exposta: string().required('Este campo é obrigatório'),
  salario: number().required('O salário é obrigatório'),
});

export class OutrasInformacoesModel {
  id = '';

  profissao = '';

  exposta = '';

  salario = '';
}
